import { render } from "./AddTaskComponent.vue?vue&type=template&id=1a3f7eb5"
import script from "./AddTaskComponent.vue?vue&type=script&lang=js"
export * from "./AddTaskComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__